'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TABS = [{
  label: 'Skills',
  id: 'skills'
}, {
  label: 'Interests',
  id: 'interests'
}, {
  label: 'Education',
  id: 'education'
}];

var initialState = {
  tabs: TABS,
  jobPages: {}
};

var updateJobPage = function updateJobPage(state, page) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _extends4.default)({}, state, {
    jobPages: (0, _extends4.default)({}, state.jobPages, (0, _defineProperty3.default)({}, page, (0, _extends4.default)({}, state.jobPages[page], payload)))
  });
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types.SHOW_MORE_INTERESTS, function (state, _ref) {
  var page = _ref.page;

  var currentShowMore = state.jobPages[page].showMore;

  return updateJobPage(state, page, {
    showMore: currentShowMore === undefined ? true : !currentShowMore
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types.CHANGE_TAB, function (state, _ref2) {
  var id = _ref2.id,
      page = _ref2.page;

  return updateJobPage(state, page, {
    currentTab: id
  });
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/reducer.js
// module id = 1205
// module chunks = 0